module.exports = __webpack_public_path__ + "static/media/HIW_steps_2.dc1b91b6.jpg";